import styled from 'styled-components';

import { Breakpoint } from '../../enums';
import { StyledComponent } from '../../interfaces';
import { ValidationBar } from '../validationBar/validationBar.component';

import { FieldContainerProps, StyledValidationBarProps } from './formField.types';

export const Container: StyledComponent<'div'> = styled.div``;

export const StyledValidationBar: StyledComponent<typeof ValidationBar, StyledValidationBarProps>
  = styled(ValidationBar)<StyledValidationBarProps>`
    ${({ $position }: StyledValidationBarProps): string => $position === 'top' ? `
      margin-bottom: 12px;
    ` : `
      margin-top: 12px;
    `}

    & + & {
      margin-top: 12px;
    }
  `;

export const FieldContainer: StyledComponent<'div', FieldContainerProps> = styled.div<FieldContainerProps>`
  max-width: ${({ $fullWidth }: FieldContainerProps): string => $fullWidth ? 'none' : '408px'};

  @media ${Breakpoint.SmallMobile} {
    max-width: none;
  }
`;
